/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import ConstructorSection from '@/models/list/ConstructorSection';

import { CARD_TYPES, SECTION_TYPES } from './constants';

export const textDescription = () => new ConstructorSection({
  value: {
    type: SECTION_TYPES.generic,
    title: 'О курсе',
    description: 'Все говорят, что цифровизация помогает компаниям сокращать издержки и повышать эффективность управления бизнесом. Мы расскажем о конкретном кейсе того, как оцифровка даже одного этапа жизненного цикла деталей позволяет сокращать издержки на примере железнодорожной индустрии. А именно, как вагоноремонтному предприятию можно сэкономить 7 млн. рублей в год, снизить срок инвентаризации с двух недель до одного дня и минимизировать ошибки при проведении ремонта.',
  },
});

export const topAvatar = () => new ConstructorSection({
  cardsType: CARD_TYPES.topAvatarShadow,
  value: {
    type: SECTION_TYPES.generic,
    title: 'Кому подходит этот курс?',
    description: null,
    cards: [
      {
        title: 'Профессионалам в данной теме',
        description: null,
      },
      {
        title: 'Новичкам в данной теме',
        description: null,
      },
      {
        title: 'Специалистам в данной теме',
        description: null,
      },
    ],
  },
});

export const leftAvatar = () => new ConstructorSection({
  cardsType: CARD_TYPES.leftAvatar,
  value: {
    type: SECTION_TYPES.generic,
    title: 'Чему вы научитесь?',
    description: null,
    cards: [
      {
        title: 'Полностью изучите навык номер 1',
        description: null,
      },
      {
        title: 'Полностью изучите навык номер 2',
        description: null,
      },
      {
        title: 'Полностью изучите навык номер 3',
        description: null,
      },
    ],
  },
});

export const questions = () => new ConstructorSection({
  cardsType: CARD_TYPES.question,
  value: {
    type: SECTION_TYPES.generic,
    title: 'Часто задаваемые вопросы',
    description: null,
    cards: [
      {
        title: 'Как я получу доступ к курсу?',
        description: 'Сразу после оплаты на данной странице Вы получите письмо с доступом к курсу на указанный email-адрес.',
      },
      {
        title: 'Как можно оплатить курс?',
        description: 'Чтобы оплатить доступ к курсу, нажмите на кнопку «Записаться» на этой странице. Оплату можно совершить банковской картой, либо одним из предложенных на странице платежа способом.',
      },
    ],
  },
});

export const units = () => new ConstructorSection({
  value: {
    type: SECTION_TYPES.units,
    title: 'Структура курса',
    description: null,
  },
});

export const progress = () => new ConstructorSection({
  cardsType: CARD_TYPES.progress,
  value: {
    type: SECTION_TYPES.generic,
    title: 'Как проходит обучение?',
    description: null,
    cards: [
      {
        title: 'Запишитесь в набор',
        description: 'Выберите удобные для вас даты обучения и запишитесь в набор',
      },
      {
        title: 'Привяжите Telegram',
        description: 'Вы можете обучаться прямо через Телеграм!',
        avatar: {
          value: '$telegram',
          isIcon: true,
        },
      },
      {
        title: 'Выполняйте задания и тесты',
        description: 'Проходите тесты и выполняйте практические работы с проверкой от преподавателя',
      },
      {
        title: 'Получите диплом!',
        description: 'Он придет вам прямо на почту!',
        avatar: {
          value: 'mdi-certificate-outline',
          isIcon: true,
        },
      },
    ],
  },
});

export const contacts = () => new ConstructorSection({
  cardsType: CARD_TYPES.topAvatarShadow,
  value: {
    type: SECTION_TYPES.generic,
    title: 'Куда обратится?',
    description: null,
    cards: [
      {
        title: 'ФИО',
        description: 'Иванов Иван Иванович',
        avatar: {
          value: 'mdi-account',
          isIcon: true,
        },
      },
      {
        title: 'Телефон',
        description: '+7 (999) 999-99-99',
        avatar: {
          value: 'mdi-cellphone',
          isIcon: true,
        },
      },
      {
        title: 'Email',
        description: '<EMAIL>',
        avatar: {
          value: 'mdi-email-outline',
          isIcon: true,
        },
      },
    ],
  },
});
export const documents = () => new ConstructorSection({
  cardsType: CARD_TYPES.document,
  value: {
    type: SECTION_TYPES.documents,
    title: 'Документы',
    description: null,
  },
});
export const links = () => new ConstructorSection({
  value: {
    type: SECTION_TYPES.links,
    title: 'Полезные ссылки',
    description: null,
  },
});
export const gallery = () => new ConstructorSection({
  value: {
    type: SECTION_TYPES.gallery,
    title: 'Галерея',
    description: null,
  },
});
export const video = () => new ConstructorSection({
  cardsType: CARD_TYPES.video,
  value: {
    type: SECTION_TYPES.video,
    title: 'Видео галерея',
    description: null,
  },
});

export const defaultSectionsList = {
  course: [
    textDescription(),
    topAvatar(),
    leftAvatar(),
    questions(),
    units(),
    progress(),
  ],
  mentoring: [
    contacts(),
  ],
};

export const pickSectionLists = {
  course: {
    textDescription: {
      name: 'Текст и заголовок',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-01.svg?inline'),
      component: textDescription(),
    },
    leftAvatar: {
      name: 'Аватар слева',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-03.svg?inline'),
      component: leftAvatar(),
    },
    topAvatar: {
      name: 'Аватар сверху',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-04.svg?inline'),
      component: topAvatar(),
    },
    questions: {
      name: 'Вопросы и ответы',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-02.svg?inline'),
      component: questions(),
    },
    progress: {
      name: 'Прогресс',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-05.svg?inline'),
      component: progress(),
    },
    units: {
      name: 'Список тем',
      description: 'В этом блоке будут выведены все темы курса',
      component: units(),
    },
  },
  mentoring: {
    links: {
      name: 'Ссылки',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-06.svg?inline'),
      component: links(),
    },
    contacts: {
      name: 'Контакты',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-04.svg?inline'),
      component: topAvatar(),
    },
    gallery: {
      name: 'Галерея',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-07.svg?inline'),
      component: gallery(),
    },
    video: {
      name: 'Видео галерея',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-08.svg?inline'),
      component: video(),
    },
    documents: {
      name: 'Документы',
      img: require('@/assets/sdo-constructor/sdo-previews-constructor-09.svg?inline'),
      component: documents(),
    },
  },
};
